<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <Table
        :fields="fields"
        :items="list"
        type="List"
        :loading="loading"
        :limit="limit"
        :setLimit="setLimit"
        :page="page"
        :setPage="setPage"
        :search="search"
        :gSearch="gSearch"
        :filtered="filtered"
        :actions="actions"
        :actionEvent="actionEvent"
        :eventBtn="eventBtn"
        />
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';
    import Table from "@/components/Table"; 

    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.quickNote'), url: "/Defination/QuickNote" },
    ];
    let fields = [
        { key: "description", label: i18n.t('defination.quickNotes.list.description'), keys: ["description"] },
        { key: "status_icon", label: i18n.t('defination.quickNotes.list.is_show_user'), keys: ["is_show_user"] },
        //{ key: "type", type:"badge", label: i18n.t('defination.quickNotes.list.type'), keys: ["type"] },
        { key: "actions", label: i18n.t('defination.quickNotes.list.actions'), keys:["actions"]}
        ];
    export default {
        name: "QuickNote",
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"QuickNote",
                modalName: "",
                fields,
                limit: 10,
                page: 1,
                offset: 0,
                dismissCountDown: 0,
                params: {
                    limit: 10,
                    offset: 0
                },
                filtered: [
                    "description",
                    "status_icon",
                    "type",
                    "actions"
                ],
                actions: [
                    { key: "delete", text: i18n.t('general.delete') }
                ],
            }
        },
        async created() {
            await this.$store.dispatch("listQuickNotes");
        },
        components:{
            BreadCrumb, Modals, Table
        },
        methods:{
            search(){
            
            },
            gSearch(data){
            
            },
            setLimit: function(limit) {
            this.limit = limit;
            this.$store.dispatch("listQuickNotes", this.params);
            },
            setPage: function(page) {
            if (page > 0) {
                this.page = page;
                this.offset = (page - 1) * this.limit;
                this.$store.dispatch("listQuickNotes", this.params);
            }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                this.modalProps = props
                this.modalName = modal
            },
            actionEvent: async function(key, data) {
            switch (key) {
                case "edit":
                //this.openModal(true, "edit", data);
                //edit kısmı apide yok.
                // edit kısmı düşünülürse buradan tetiklenir
                break;
                case "delete":
                this.openModal(true, "delete", {...data,rank:parseInt(data.rank)});
                break;
                case "add":
                this.openModal(true, "add");
                break;
            }
            },
        },
        computed:{
        loading() {
            return this.$store.getters.getDefinationLoading;
        },
        list() {
            return this.$store.getters.getQuickNotes
            /*.map(note => {
                return {...note, typeBadge: note.type == 1 ? 'Trafik List' : 'Teknik Servis'}
            })*/
        },
        eventBtn(){
            return {
                text:i18n.t('general.add'),
                clicked:()=>{
                this.actionEvent("add");
                }
            }
        }
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/QuickNote.vue